import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

export interface BulkUpdateMemberRequest {
  departments: number[];
  clients: number[];
  assign: boolean;
}

const useBulkUpdateMemberApi = (companyId: string) => {
  const call = useCallback(
    async (body?: BulkUpdateMemberRequest) => {
      try {
        const res = await axiosInstance.post(api.bulkUpdateMember(companyId), body);
        return res;
      } catch (error) {
        throw new Error(error);
      }
    },
    [companyId]
  );

  const { execute, isLoading } = useAsync(call, false);

  return { bulkUpdateMember: execute, isBulkUpdateMemberLoading: isLoading };
};

export default useBulkUpdateMemberApi;
